<template>
    <div class="wapper">
        <el-container style="100%">
            <el-main style="background: #fff">
                <div class="table-wrap" v-show="listShow">
                    <div class="handle-box3">
                        <el-form
                                :inline="true"
                                ref="form"
                                :model="searchForm"
                                class="demo-form-inline"
                        >
                            <div class="uers-left">
                                <el-form-item label="时间：">
                                    <el-select
                                            v-model="searchForm.type"
                                            clearable
                                            placeholder="选择类型"
                                    >
                                        <el-option
                                                v-for="(type, index) in types"
                                                :label="type.name"
                                                :key="index"
                                                :value="type.value"
                                        >{{ type.name }}
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="标签：">
                                    <el-select v-model="searchForm.label" placeholder="选择标签">
                                        <el-option label="全部" value="">全部</el-option>
                                        <el-option
                                                v-for="(type, i) in labels"
                                                :key="i"
                                                :label="type.name"
                                                :value="type.name"
                                        >
                                            {{ type.name }}
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="注册通道：">
                                    <el-select
                                            placeholder="注册通道："
                                            clearable
                                            @change="change()"
                                            v-model="searchForm.registerId"
                                            class="el-input-position"
                                    >
                                        <el-option label="全部" value="">全部</el-option>
                                        <el-option
                                                v-for="(item, index) in registers"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.registerId"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="调研项：">
                                    <el-select
                                            placeholder="调研项："
                                            clearable
                                            v-model="searchForm.propertyId"
                                            class="el-input-position"
                                    >
                                        <el-option label="全部" value=""
                                        >
                                            <div @click="selectOption(null)">全部</div>
                                        </el-option
                                        >
                                        <el-option
                                                v-if="item.name"
                                                v-for="(item, index) in personalPropertys"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.propertyId"
                                        >
                                            <div @click="selectOption(item)">
                                                {{ item.name }}
                                            </div>
                                        </el-option
                                        >
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="调研选项：">
                                    <el-select
                                            placeholder="调研选项："
                                            clearable
                                            v-model="searchForm.propertyValue"
                                            class="el-input-position"
                                    >
                                        <el-option label="全部" value="">全部</el-option>
                                        <el-option
                                                v-if="item"
                                                v-for="(item, index) in values"
                                                :key="index"
                                                :label="item"
                                                :value="item"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="uers-right">
                <span class="btn-r">
                  <el-button
                          style="float: right; margin-left: 10px"
                          type="primary"
                          @click="searchData"
                          icon="el-icon-search"
                  >查询</el-button
                  >
                </span>
                            </div>
                        </el-form>
                        <el-form
                                ref="tableData"
                                :model="list"
                                :rules="rules1"
                                class="demo-ruleForm"
                        >
                            <el-table
                                    :data="list.tableData"
                                    style="width: 100%; margin-bottom: 30px; z-index: 1"
                            >
                                <el-table-column label="字段" width="300">
                                    <template slot-scope="scope" prop="name">
                                        <el-form-item
                                                :prop="'tableData.' + scope.$index + '.name'"
                                                :rules="rules1.name"
                                        >
                                            <el-select
                                                    placeholder="字段"
                                                    clearable
                                                    @change="changeName(scope.row, scope.$index)"
                                                    v-model="scope.row.name"
                                                    class="el-input-position"
                                            >
                                                <el-option
                                                        v-for="(item, index) in propertys"
                                                        :key="index"
                                                        :label="item.name"
                                                        :value="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="类型" width="200">
                                    <template slot-scope="scope">
                                        <el-form-item
                                                :prop="'tableData.' + scope.$index + '.type'"
                                                :rules="rules1.type"
                                        >
                                            <el-select
                                                    :disabled="scope.$index == 0"
                                                    placeholder="类型"
                                                    clearable
                                                    v-model="scope.row.type"
                                                    class="el-input-position"
                                            >
                                                <el-option
                                                        v-for="(item, index) in inputTypes"
                                                        :key="index"
                                                        :label="item.name"
                                                        :value="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="值" width="400">
                                    <template slot-scope="scope" prop="name">
                                        <el-form-item
                                                :prop="'tableData.' + scope.$index + '.name'"
                                                :rules="rules1.value"
                                        >
                                            <el-input
                                                    v-if="
                          scope.row.type != 'sort' &&
                          (scope.row.name.indexOf('Date') == -1 ||
                            scope.$index == 0)
                        "
                                                    v-model="scope.row.value"
                                                    placeholder="值"
                                                    clearable
                                                    type="text"
                                                    class="el-input-position"
                                            ></el-input>

                                            <el-date-picker
                                                    v-if="
                          scope.row.type != 'sort' &&
                          scope.row.name.indexOf('Date') > -1 &&
                          scope.$index > 0
                        "
                                                    clearable
                                                    v-model="scope.row.value"
                                                    type="datetime"
                                                    placeholder="日期时间"
                                            ></el-date-picker>
                                            <el-select
                                                    v-if="scope.row.type == 'sort'"
                                                    v-model="scope.row.value"
                                            >
                                                <el-option label="升序" value="asc">升序</el-option>
                                                <el-option label="降序" value="desc">降序</el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="关联">
                                    <template slot-scope="scope" prop="join">
                                        <el-form-item
                                                :prop="'tableData.' + scope.$index + '.join'"
                                                :rules="rules1.join"
                                        >
                                            <el-select
                                                    :disabled="scope.$index == 0"
                                                    v-if="scope.row.type != 'sort'"
                                                    placeholder="关联"
                                                    clearable
                                                    v-model="scope.row.join"
                                                    class="el-input-position"
                                            >
                                                <el-option
                                                        v-for="(item, index) in joins"
                                                        :key="index"
                                                        :label="item.name"
                                                        :value="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column width="200" label="操作">
                                    <template slot-scope="scope">
                                        <el-button
                                                v-if="scope.$index > 0"
                                                type="danger"
                                                plain
                                                @click="deleterow(scope.$index, scope.row)"
                                        >删除
                                        </el-button
                                        >
                                        <el-button type="primary" plain @click="addRow"
                                        >新增
                                        </el-button
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column width="10"></el-table-column>
                            </el-table>
                        </el-form>
                    </div>

                    <div class="fb">
                        <div class="uers-right">
              <span class="btn-r">
                <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        @click="addSubmit"
                >新增</el-button
                >
                <el-button
                        type="primary"
                        plain
                        icon="el-icon-printer"
                        @click="print"
                >打印</el-button
                >
                <el-button
                        type="primary"
                        icon="el-icon-export"
                        @click="exportExcel()"
                >导出人员</el-button
                >
                <el-button
                        type="primary"
                        icon="el-icon-export"
                        @click="exportProperty()"
                >导出调研项</el-button
                >
              </span>
                            <el-popover
                                    placement="bottom"
                                    title="批量导入"
                                    width="220"
                                    trigger="click"
                            >
                                <div>
                                    <el-upload
                                            class="upload-demo"
                                            :action="action"
                                            :auto-upload="false"
                                            :on-change="uploadChange"
                                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    >
                                        <el-button size="small" type="primary"
                                        >选择导入模板
                                        </el-button
                                        >
                                    </el-upload>
                                    <el-button
                                            type="success"
                                            @click="download"
                                            plain
                                            icon="el-icon-download"
                                            class="down-template"
                                    >下载模板
                                    </el-button
                                    >
                                </div>
                                <p class="import-text">只能选择 .xls .xlsx 文件</p>
                                <div>
                                    <el-button type="success" @click="importData"
                                    >开始导入
                                    </el-button
                                    >
                                </div>
                                <el-button
                                        type="primary"
                                        plain
                                        icon="el-icon-upload2"
                                        slot="reference"
                                >导入人员
                                </el-button
                                >
                            </el-popover
                            >&nbsp;&nbsp;&nbsp;
                        </div>
                        <el-form :inline="true" class="demo-form-inline handle-search">
                            <div class="usrs-right">
                                <el-form-item label="标签设置：">
                                    <el-select v-model="label" placeholder="选择标签">
                                        <el-option
                                                v-for="(type, i) in labels"
                                                :key="i"
                                                :label="type.name"
                                                :value="type.name"
                                        >
                                            {{ type.name }}
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button
                                            type="primary"
                                            icon="el-icon-edit"
                                            @click="saveLabel"
                                    >保存
                                    </el-button
                                    >
                                    <el-button
                                            type="primary"
                                            icon="el-icon-delete"
                                            @click="delLabel"
                                    >删除
                                    </el-button
                                    >
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <el-table
                            :data="dataList"
                            height="100%"
                            border
                            class="tabbox"
                            ref="multipleTable"
                            :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                            @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                                type="selection"
                                width="55"
                                align="center"
                        ></el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        @click="handleEdit(scope.$index, scope.row)"
                                >编辑
                                </el-button
                                >
                                <el-button
                                        type="text"
                                        class="red"
                                        @click="handleDelete(scope.$index, scope.row)"
                                >删除
                                </el-button
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="isSign"
                                width="55"
                                label="签到"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.isSign == 1 ? "是" : "否" }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="isSign"
                                width="55"
                                label="通行"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.isPassage == 1 ? "是" : "是" }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="code"
                                width="100"
                                label="码值"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.code }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                width="120"
                                label="姓名"
                                align="center"
                        >
                            <template slot-scope="scope">
                <span>{{ scope.row.name }}</span
                ><br/>
                                <span>{{ scope.row.nameEn }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="sex"
                                width="80"
                                label="性别/称呼"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.sex }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="phone"
                                width="100"
                                label="手机"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.area }}</span>
                                <span>{{ scope.row.phone }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="openId"
                                width="100"
                                label="标签"
                                align="center"
                        >
                            <template slot-scope="scope">
                <span
                        v-if="scope.row.openId"
                        v-for="item in scope.row.openId
                    ? scope.row.openId.split('|')
                    : ['']"
                >{{ item }}<br
                /></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="email"
                                width="100"
                                label="邮箱"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.email }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="company"
                                width="250"
                                label="公司/职务"
                                align="center"
                        >
                            <template slot-scope="scope">
                <span>{{ scope.row.company }} {{ scope.row.position }}</span
                ><br/>
                                <span
                                >{{ scope.row.companyEn }} {{ scope.row.positionEn }}</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="company"
                                width="100"
                                label="电话/传真"
                                align="center"
                        >
                            <template slot-scope="scope">
                <span>{{ scope.row.telNo }}</span
                ><br/>
                                <span>{{ scope.row.faxNo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="idCard"
                                width="80"
                                label="流水号"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.idCard }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="position"
                                width="150"
                                label="地址"
                                align="center"
                        >
                            <template slot-scope="scope">
                <span
                >{{ scope.row.countryArea }}-{{ scope.row.province }}-{{
                    scope.row.city
                  }}-{{ scope.row.address }}</span
                >
                                <span>{{ scope.row.addressEn }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="position"
                                width="100"
                                label="来源"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.source }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="createDate"
                                width="150"
                                label="创建时间"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.createDate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="signDate"
                                width="150"
                                label="签到时间"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.signDate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="passeageDate"
                                width="150"
                                label="通行时间"
                                align="center"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.passeageDate }}</span>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-pagination
                            class="pag"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[5, 10, 15, 20, 50, 100]"
                            :page-size="pagesize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                            background
                    ></el-pagination>
                </div>
                <DeleteDialog
                        :delVisible="delVisible"
                        @deleteData="deleteData"
                        @handleCloseVisible="handleCloseVisible"
                ></DeleteDialog>
                <EditExhibitorsPersonal
                        :editShow="editShow"
                        :editData="editData"
                        @backFunStu="getFunStu"
                ></EditExhibitorsPersonal>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import EditExhibitorsPersonal from "../../components/major/EditExhibitorsPersonal";
    import DeleteDialog from "../../components/public/DeleteConfim";

    var inputTypes = [
        //equal,notEqual,like,notLike,in,greaterThan,greaterThanOrEqualTo,lessThan,lessThanOrEqualTo
        {name: "字段排序/sort", value: "sort"},
        {name: "等于/equal", value: "equal"},
        {name: "不等于/notEqual", value: "notEqual"},
        {name: "模糊匹配/like", value: "like"},
        {name: "不匹配/notLike", value: "notLike"},
        {name: "包含/in", value: "in"},
        {name: "大于/greaterThan", value: "greaterThan"},
        {name: "小于/lessThan", value: "lessThan"},
        {name: "数字小于/lt", value: "lt"},
        {name: "数字大于/gt", value: "gt"},
        {name: "大于等于/greaterThanOrEqualTo", value: "greaterThanOrEqualTo"},
        {name: "小于等于/lessThanOrEqualTo", value: "lessThanOrEqualTo"},
        {name: "数字大于等于/ge", value: "ge"},
        {name: "数字小于等于/le", value: "le"},
    ];
    var propertys = [
        {name: "姓名/name", value: "name"},
        {name: "称呼性别/sex", value: "sex"},
        {name: "公司中文/company", value: "company"},
        {name: "公司英文/company En", value: "companyEn"},
        {name: "导入批次号", value: "batch"},
        {name: "职务/position", value: "position"},
        {name: "流动电话/phone", value: "phone"},
        {name: "电邮/email", value: "email"},
        {name: "电话/texNo", value: "texNo"},
        {name: "传真/faxNo", value: "faxNo"},
        {name: "码值/code", value: "code"},
        {name: "标签/label", value: "openId"},
        {name: "证件号码/idCard", value: "idCard"},
        {name: "国家地区/countryArea", value: "countryArea"},
        {name: "省份/province", value: "province"},
        {name: "城市/city", value: "city"},
        {name: "地址/address", value: "address"},
        {name: "语言/lang", value: "lang"},
        {name: "创建时间", value: "createDate"},
        {name: "签到办证时间", value: "signDate"},
        {name: "通行入场时间", value: "passageDate"},
        {name: "是否打印证件", value: "isSign"},
        {name: "是否通过闸机", value: "isPassage"},
    ];
    export default {
        name: "search",
        data() {
            return {
                label: "",
                action: localStorage.getItem("url"),
                editData: {},
                listShow: true,
                editShow: false,
                delVisible: false,
                dataList: [],
                multipleSelection: [],
                total: 0, //总条数
                currentPage: 1, //初始页
                pagesize: 5, // 每页的数据
                labels: [],
                uploadUrl: "",
                uploadDate: "",
                projectId: localStorage.getItem("project_Id"),
                registers: [],
                searchForm: {
                    pageIndex: 1,
                    pageSize: 5,
                    projectId: localStorage.getItem("project_Id"),
                    time: localStorage.getItem("startDate"),
                    type: "-1",
                    propertyId: "",
                    registerId: "",
                    propertyValue: "",
                    label: "",
                },
                list: {
                    tableData: [
                        {name: "createDate", type: "sort", value: "desc", join: "and"},
                    ],
                },
                inputTypes: inputTypes,
                propertys: propertys,
                personalPropertys: [],
                types: [
                    {name: "全部", value: "-1"},
                    {name: "展前", value: "0"},
                    {name: "展期", value: "1"},
                ],
                joins: [
                    {name: "或", value: "or"},
                    {name: "且", value: "and"},
                    {name: "非", value: "not"},
                ],
                values: [],
                rules1: {
                    type: [{required: true, message: "类型不能为空", trigger: "blur"}],
                    name: [{required: false, message: "名称不能为空", trigger: "blur"}],
                    join: [{required: true, message: "关联不能为空", trigger: "blur"}],
                    value: [{required: false, message: "值不能为空", trigger: "blur"}],
                },
            };
        },
        created() {
            this.loadData();
            this.getLabel();
            this.getProperty();
            this.search();
        },

        methods: {
            delLabel() {
                if (this.label == "") {
                    this.$message.error("请选择标签");
                    return;
                }
                if (confirm("是否将当前查询所有数据删除标签【" + this.label + "】？")) {
                    const loading = this.$loading({
                        lock: true,
                        text: "Loading",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)",
                    });
                    this.searchForm.labelSet = "delete";
                    this.$axios
                        .post(`/Personal/Label/` + this.label, this.searchForm)
                        .then((res) => {
                            loading.close();
                            if (!res.data.hasError) {
                                this.$message.success("删除完成");
                                this.dataList = [...res.data.data];
                                this.total = res.data.total;
                            } else {
                                this.$message.error("保存失败");
                            }
                        })
                        .catch((a) => {
                            loading.close();
                            this.$message.error("保存失败");
                        });
                }
            },
            saveLabel() {
                if (this.label == "") {
                    this.$message.error("请选择标签");
                    return;
                }
                if (confirm("是否将当前查询所有数据保存为标签【" + this.label + "】？")) {
                    const loading = this.$loading({
                        lock: true,
                        text: "Loading",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)",
                    });
                    this.searchForm.labelSet = "add";
                    this.$axios
                        .post(`/Personal/Label/` + this.label, this.searchForm)
                        .then((res) => {
                            loading.close();
                            if (!res.data.hasError) {
                                this.$message.success("保存完成");
                                this.dataList = [...res.data.data];
                                this.total = res.data.total;
                            } else {
                                this.$message.error("保存失败");
                            }
                        })
                        .catch((a) => {
                            loading.close();
                            this.$message.error("保存失败");
                        });
                }
            },
            addSubmit() {
                this.editData = null;
                this.listShow = false;
                this.editShow = true;
            },
            downloadFile(data) {
                if (!data) {
                    return;
                }
                const link = document.createElement("a");
                let blob = new Blob([data], {type: "application/vnd.ms-excel"});
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);

                link.setAttribute("download", "记录信息" + ".xls");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            exportExcel() {
                const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                this.$axios
                    .post(`/Personal/Query/Export`, this.searchForm)
                    .then((res) => {
                        loading.close();
                        if (res.data.data) {
                             window.open(res.data.data, '_self');
                            // this.$download(res.data.data, '导出证件.xlsx');
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
                    .catch((a) => {
                        loading.close();
                        this.$message.error("导出失败");
                    });
            },
            exportProperty() {
                const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                this.$axios
                    .post(`/PersonalProperty/Export`, this.searchForm)
                    .then((res) => {
                        loading.close();
                        if (res.data.data) {
                             window.open(res.data.data, '_self');
                            // this.$download(res.data.data, '导出证件.xlsx');
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
                    .catch((a) => {
                        loading.close();
                        this.$message.error("导出失败");
                    });
            },
            uploadChange(file, fileList) {
                let inputDOM = this.$refs.inputer; // 通过DOM取文件数据

                this.file = event.currentTarget.files[0];
                var rABS = false; //是否将文件读取为二进制字符串
                var f = this.file;
                var formData = new FormData();
                formData.append("file", f);
                this.$axios
                    .post("/Upload/File", formData, {
                        headers: {"Content-Type": "multipart/form-data"},
                    })
                    .then((resp) => {
                        this.uploadUrl = resp.data.data;
                        this.uploadDate = resp.data.message;

                        var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
                        FileReader.prototype.readAsBinaryString = function (f) {
                            var binary = "";
                            var rABS = false; //是否将文件读取为二进制字符串
                            var pt = this;
                            var wb; //读取完成的数据
                            var outdata;
                            var reader = new FileReader();
                            reader.onload = function (e) {
                                var bytes = new Uint8Array(reader.result);
                                var length = bytes.byteLength;
                                for (var i = 0; i < length; i++) {
                                    binary += String.fromCharCode(bytes[i]);
                                }
                                var XLSX = require("xlsx");
                                if (rABS) {
                                    wb = XLSX.read(btoa(fixdata(binary)), {
                                        //手动转化
                                        type: "base64",
                                    });
                                } else {
                                    wb = XLSX.read(binary, {
                                        type: "binary",
                                    });
                                } // outdata就是你想要的东西 excel导入的数据
                                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
                                let ar = [];
                                outdata.map((v) => {
                                    let obj = {};
                                    obj.name = v.姓名;
                                    obj.nameEn = v.英文姓名;
                                    obj.sex = v.性别称呼;
                                    obj.email = v.邮箱;
                                    obj.avatar = v.已审核;
                                    obj.company = v.公司;
                                    obj.companyEn = v.公司英文;
                                    obj.position = v.职务;
                                    obj.idCard = v.证件号码;
                                    obj.phone = v.手机号码;
                                    obj.area = v.地区号码;
                                    obj.countryArea = v.国家地区;
                                    obj.province = v.省份;
                                    obj.city = v.城市;
                                    obj.address = v.地址;
                                    obj.code = v.码值;
                                    obj.telNo = v.电话号码;
                                    obj.faxNo = v.传真号码;
                                    obj.phoneNo = v.移动电话;
                                    obj.booth = v.展位号;
                                    obj.lang = v.语言;
                                    obj.openId = v.标签;
                                    obj.source = v.来源;
                                    obj.positionEn = v.职务英文;
                                    obj.remark = v.备注;
                                    obj.addressEn = v.地址英文;
                                    obj.documentType = v.证件类型;
                                    obj.batch = resp.data.message;
                                    ar.push(obj);
                                });
                                localStorage.setItem("attr", JSON.stringify(ar));
                            };
                            reader.readAsArrayBuffer(f);
                        };
                        if (rABS) {
                            reader.readAsArrayBuffer(f);
                        } else {
                            reader.readAsBinaryString(f);
                        }
                    });
            },
            importData() {
                if (this.searchForm.registerId != "") {
                    this.attr = JSON.parse(localStorage.getItem("attr"));
                    if (this.attr && this.attr.length > 0) {
                        this.$axios
                            .post("/ProjectFile/", {
                                projectId: this.projectId,
                                documentTypeId: this.searchForm.registerId,
                                url: this.uploadUrl,
                                name: "人员导入",
                                code: this.uploadDate,
                                remark: "人员导入" + this.uploadDate,
                            })
                            .then((res) => {
                                if (res.data.hasError == false) {
                                    const loading = this.$loading({
                                        lock: true,
                                        text: "Loading",
                                        spinner: "el-icon-loading",
                                        background: "rgba(0, 0, 0, 0.7)",
                                    });
                                    this.$axios
                                        .patch("/Personal/" + this.searchForm.registerId, this.attr)
                                        .then((res) => {
                                            if (res.data.hasError == false) {
                                                loading.close();
                                                this.searchSubmit();
                                                localStorage.setItem("attr", null);
                                                this.$message.success(res.data.message);
                                            } else {
                                                this.$message.error(res.data.message);
                                                loading.close();
                                            }
                                        })
                                        .catch(function () {
                                            loading.close();
                                        });
                                }
                            })
                            .catch(function () {
                                loading.close();
                            });
                    } else {
                        this.$message.error("没有可上传的数据");
                    }
                } else {
                    this.$message.error("请选择注册通道");
                }
            },
            download() {
                var url = localStorage.getItem("url");
                if (url.lastIndexOf("/api") == url.indexOf("/api")) {
                    window.open(url.replace("/api", "/") + "/static/data/用户模板.xlsx");
                } else {
                    window.open(
                        url.substring(0, url.lastIndexOf("/api")) +
                        "/static/data/用户模板.xlsx"
                    );
                }
            },
            deleteData() {
                this.$axios.delete(`/Personal/${this.personal_Id}`).then((res) => {
                    if (res.data.hasError) {
                        this.$message.error(res.data.message);
                    } else {
                        this.$message.success("删除成功！");
                        this.delVisible = false;
                        this.search();
                    }
                });
            },
            getLabel() {
                this.$axios.get("/Label/Project/" + this.projectId).then((res) => {
                    if (res.data.hasError == false) {
                        this.labels = [...res.data.data];
                    }
                });
            },
            selectOption(item) {
                this.values = [];
                if (item) {
                    let opts = item.options.split("|");
                    let opts1 = item.englishOption.split("|");
                    let opts2 = item.traditionalOptions.split("|");

                    for (let i = 0; i < opts.length; i++) {
                        if (opts1.length > i && opts2.length > i) {
                            this.values.push(opts[i] + "," + opts1[i] + "," + opts2[i]);
                        } else if (opts1.length > i) {
                            this.values.push(opts[i] + "," + opts1[i]);
                        } else if (opts2.length > i) {
                            this.values.push(opts[i] + "," + opts2[i]);
                        } else {
                            this.values.push(opts[i]);
                        }
                    }
                }
            },
            handleSizeChange(val) {
                this.pagesize = val;
                this.search();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.search();
            },
            handleDelete(index, row) {
                this.personal_Id = row.personalId;
                this.delVisible = true;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleEdit(index, row) {
                this.editData = row;
                this.listShow = false;
                this.editShow = true;
            },
            getFunStu() {
                this.listShow = true;
                this.editShow = false;
                this.search();
            },
            deleteData() {
                this.$axios.delete(`/Personal/${this.personal_Id}`).then((res) => {
                    if (res.data.hasError) {
                        this.$message.error(res.data.message);
                    } else {
                        this.$message.success("删除成功！");
                        this.delVisible = false;
                        this.search();
                    }
                });
            },
            change() {
                this.getProperty();
            },
            changeName(item, index) {
                if (index > 0) {
                    if (item.name.indexOf("Date") > -1) {
                        item.value = new Date(
                            new Date(new Date().toLocaleDateString()).getTime() +
                            24 * 60 * 60 * 1000 -
                            1
                        );
                    } else {
                        item.value = "";
                    }
                }
            },
            getFunStu() {
                this.listShow = true;
                this.editShow = false;
                this.search();
            },
            loadData() {
                this.$axios
                    .get("/Register/Project/" + this.projectId)
                    .then((res) => {
                        if (res.data.hasError == false) {
                            this.registers = [...res.data.data];
                        } else {
                            console.log(res.data.message);
                        }
                    })
                    .catch(function () {
                    });
            },
            deleterow(index, row) {
                this.list.tableData.splice(index, 1);
            },
            getProperty() {
                this.personalPropertys = [];
                this.values = [];
                this.searchForm.propertyId = "";
                this.searchForm.propertyValue = "";
                this.$axios
                    .get("/Property/register/" + this.searchForm.registerId)
                    .then((res) => {
                        if (res.data.data) {
                            res.data.data.forEach((element) => {
                                if (element.options && element.options.length > 0) {
                                    this.personalPropertys.push(element);
                                }
                            });
                            this.personalPropertys = this.personalPropertys.sort((a, b) => {
                                return a.indexNo - b.indexNo;
                            });
                        }
                    })
                    .catch(function () {
                    });
            },
            addRow() {
                this.list.tableData.push({
                    name: "name",
                    type: "equal",
                    value: "",
                    join: "and",
                });
            },
            print() {
                if (this.$refs.multipleTable.selection.length > 0) {
                    let codes = [];
                    this.$refs.multipleTable.selection.forEach((element) => {
                        codes.push(element.code);
                    });
                    window.open(
                        localStorage.getItem("url") +
                        "/prints/" +
                        this.$refs.multipleTable.selection[0].documentId +
                        "?codes=" +
                        codes.join(",")
                    );
                } else {
                    this.$message.error("请选择打印行");
                }
            },
            handleCloseVisible() {
                this.personal_Id = "";
                this.delVisible = false;
            },
            searchData() {
                this.currentPage = 1;
                this.search();
            },
            search() {
                this.searchForm.pageIndex = this.currentPage - 1;
                this.searchForm.pageSize = this.pagesize;
                this.searchForm.list = this.list.tableData;
                this.$axios
                    .post("/Personal/Query", this.searchForm)
                    .then((res) => {
                        if (res.data.hasError == false) {
                            this.dataList = [...res.data.data];
                            this.total = res.data.total;
                        }
                    })
                    .catch(function () {
                    });
            },
        },
        components: {
            EditExhibitorsPersonal,
            DeleteDialog,
        },
    };
</script>
<style lang="scss" scope>
    .fb {
        position: inherit !important;
        margin-bottom: 10px;
    }

    .table-wrap {
        margin-left: 10px;
        height: 100%;
    }

    .el-main {
        border-radius: 5px;
        position: relative;
    }

    .uers-left {
        float: left;
    }

    .uers-right {
        float: right;
    }

    .table-wrap {
        overflow-y: auto !important;
    }

    .uers-import {
        margin-right: 30px;
        float: right;
        width: 240px;
    }

    .upload-excel {
        float: left;
    }

    .import-bnt {
        float: right;
    }

    .el-upload {
        height: 32px !important;
        line-height: 32px !important;
        width: 120px !important;
    }

    .el-upload--text {
        border: 0;
    }

    .file-up {
        width: 100px;
        position: absolute;
        height: 32px;
        opacity: 0;
    }

    .import-text {
        margin: 15px 0;
    }

    .el-upload--text {
        width: 110px;
        height: 32px;
        line-height: 32px;
        border: 0;
    }

    .down-template {
        position: absolute;
        top: 40px;
        right: 10px;
    }

    .el-pagination {
        display: inline-block;
    }
</style>